export default {
      id: "ar_jeunesse-usage",
      viewBox: "0 0 60 60",
      url: "../dist/images/" + "sprite.svg#ar_jeunesse-usage",
      toString: function () {
        return this.url;
      }
    }